<script lang="ts">
  import { delay } from '~/animations/utils.svelte';

  import Board, { initializeSelection } from '../board/Board.svelte';
  import { swap } from '../algorithms/gameLogic';
  import type { Coord } from '../types';
  import { onMount } from 'svelte';
  import GameContext from '~/store/GameContext.svelte';
  import { flipAnimation } from '~/animations/flip.svelte';
  import { Tutorial } from '~/store/daily.svelte';
  import { animationSpeed } from '~/animations/utils.svelte';
  import { lettersToBoard } from '~/board/utils';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';

  type Props = {
    play: boolean;
  };
  const props: Props = $props();

  const getBoard = () =>
    lettersToBoard([
      ['A', 'W', 'A'],
      ['D', 'O', 'A'],
      ['A', 'R', 'A'],
      ['A', 'A', 'A'],
    ]);

  const tutorial = new Tutorial(getBoard());

  let selected = $state<[Coord, Coord]>();
  let s = $state(initializeSelection());

  const runAnimation = async () => {
    await delay(1000);
    selected = [
      [1, 0],
      [3, 1],
    ];
    s.coords = ['1,0', '3,1'];
    // for stagger
    tutorial.lost = false;
    let board = $state.snapshot(tutorial.board);
    s.tiles.clear();
    s.tiles.add(board[1][0].id);
    await delay(500);
    s.tiles.add(board[3][1].id);
    await delay(500);
    board = swap(tutorial.board, ...selected);
    tutorial.board = board;
    await flipAnimation.settled();
    selected = undefined;
    s.tiles.clear();
    tutorial.highlighted = Object.fromEntries(
      [
        [0, 1],
        [1, 1],
        [2, 1],
        [3, 1],
      ].map((c) => [board[c[0]][c[1]].id, 'green']),
    );
    await delay(2000);
    tutorial.highlighted = {};
    tutorial.board = getBoard().map((r, i) =>
      r.map((t, j) => ({
        ...t,
        flipped: true,
        id: tutorial.board[i][j].id,
      })),
    );
    tutorial.lost = true;
    await delay(animationSpeed.ms * 2);
    tutorial.board.forEach((r) =>
      r.forEach((t) => {
        delete t.flipped;
      }),
    );
  };

  let mounted = false;
  onMount(() => {
    mounted = true;
    void startAnimation();
    return () => {
      mounted = false;
    };
  });

  let isPlaying = false;
  $effect(() => {
    if (props.play && !isPlaying) {
      startAnimation();
    }
  });

  const startAnimation = async () => {
    isPlaying = true;
    while (mounted && props.play) {
      await runAnimation();
    }
    isPlaying = false;
  };

  const dims = {
    width: 240,
    height: 180,
    aspect: 2 / 3,
  };
</script>

<div class="container">
  <GameContext game={tutorial}>
    <DimensionsContext {...dims}>
      <Board selected={s} disabled />
    </DimensionsContext>
  </GameContext>
</div>

<style lang="scss">
  .container {
    display: flex;
    pointer-events: none;
    :global(*) {
      pointer-events: none;
    }
  }
</style>
